import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_INTRO_TEMPLATE = [
  {
    icon: "ai",
    iconColor: "white",
    text: "AI first real time data \npipeline",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "gearWithCheckmark",
    iconColor: "white",
    text: "Automated data\n profiling & data quality\n rule recommendation,\n code generation and\n testing",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "checkmarksConnectedByALine",
    iconColor: "white",
    text: "End-to-end pipeline and \nworkflow generation",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_INTRO_DNA2 = {
  styleLeftPanel: { paddingRight: 0 },
  title: "Zero data engineering",
  text: "A cutting-edge AI-first real-time data pipeline that processes data from any \nsource, minimizing the need for manual intervention in building data \nengineering pipelines for synchronization or transformation.",
  listData: LIST_DATA_INTRO_TEMPLATE,
  next: {
    label: "FIND OUT HOW",
    onClick: () => setCurrentPage(202),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(1),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_01.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
};
